import { useCallback } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { FormItemWrapper } from "../DefaultEditorV2/FormItemWrapper";

export const useFormItem = () => {
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  const getFormItemProps = useCallback(
    ({
      className,
      labelClassName,
    }: { className?: string; labelClassName?: string } = {}) => ({
      hideDescription: true,
      hideBorder: true,
      className: classNames(
        "!p-0",
        {
          "!grid grid-cols-3 !items-center": isPropertiesPanelV2,
        },
        className,
      ),
      labelWrapperClassName: classNames("inline-flex", {
        "!w-fit": !isPropertiesPanelV2,
      }),
      childrenWrapper: FormItemWrapper,
      labelClassName: classNames(
        {
          "!font-normal text-xs": !isPropertiesPanelV2,
          "!font-normal text-xs mb-0 mr-2": isPropertiesPanelV2,
        },
        labelClassName,
      ),
    }),
    [isPropertiesPanelV2],
  );

  return {
    getFormItemProps,
  };
};
